import React from 'react'
import {Box, Typography} from "@material-ui/core";
import bigX from "./../../../assets/bigX.svg";
import {useStyles} from "./style";

interface CustomTextProps {
    sourcePage?: string;

    icon?: React.ReactNode;
}

export const BigX: React.FC<CustomTextProps> = ({sourcePage, icon = <img src={bigX} alt="No Data"/>}) => {
    const classes = useStyles();

    const elementConfig = new Map([
        ['disconnectionManagement:nullState', <div>
            <Typography className={classes.noDataText}>No Data</Typography>
            <Typography className={classes.secondaryText}>CT Portfolio Master Report and nCino Credit Package Report are
                missing</Typography>
            <Typography className={classes.secondaryText}>and need to be manually uploaded.</Typography>
        </div>],
        ['disconnectionManagement:noResult', <div>
            <Typography className={classes.noDataText}>No Results yet</Typography>
            <Typography className={classes.secondaryText}>Enter search criteria to see results.</Typography>
        </div>]
    ])

    return (
        <div className={classes.wrapper}>
            <Box className={classes.bigXBox}>
                <div>
                    {icon}
                </div>
                {elementConfig.get(sourcePage) ?? <div>
                    <Typography className={classes.noDataText}>No Data</Typography>
                    <Typography className={classes.secondaryText}>No workbook or SVB data available</Typography>
                </div>}
            </Box>
        </div>
    );
};
